"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlog = void 0;
var useBlog_1 = require("./useBlog");
Object.defineProperty(exports, "useBlog", { enumerable: true, get: function () { return useBlog_1.useBlog; } });
//# sourceMappingURL=index.js.map